<template>
  <div class="container_box details_box_styles">
    <!--返回按钮-->
    <div class="go_back" @click="goBackBtn">
      <Icon class="back_icon" type="ios-arrow-back"/>
      <span class="back_txt">{{ $t('key1002627') }}</span>
    </div>
    <!--步骤条-->
    <div class="basic_information_box" v-if="showSteps">
      <Card :bordered="false" dis-hover>
        <h2 class="title_center">{{ $t('key1004420') + detailsData.packageCode }}</h2>
        <div class="steps_box">
          <Steps :current="currentStatus">
            <Step
              v-for="(item, index) in stepsList"
              :key="index"
              :title="item.title"
              :icon="item.icon"
              :content="item.time">
            </Step>
          </Steps>
        </div>
      </Card>
    </div>
    <!--主信息-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <Tabs v-model="informationTab">
          <TabPane :label="$t('key1004417')" name="mainInformation">
            <Row type="flex" :gutter="gutterItem">
              <Col :span="ItemCol" class="basic_item" v-for="(item, index) in masterInfoList" :key="index">
                <span class="basic_title">{{ item.name }}</span>
                <span class="basic_txt">{{ detailsData[item.paramsKey] }}</span>
                <span v-if="['TEMU_S', 'TEMU_P'].includes(detailsData.orderType) && item.orderType" :style="orderTypeStyle">
                  {{ orderTypeObj[detailsData.orderType] }}
                </span>
              </Col>
            </Row>
          </TabPane>
          <TabPane :label="$t('key1004418')" name="consigneeInformation">
            <Row type="flex" :gutter="gutterItem">
              <Col :span="ItemCol" class="basic_item" v-for="(item, index) in consigneeInfoList" :key="index">
                <span class="basic_title">{{ item.name }}</span>
                <span class="basic_txt" :title="detailsData[item.paramsKey]">{{ detailsData[item.paramsKey] }}</span>
              </Col>
            </Row>
          </TabPane>
          <TabPane :label="$t('key1004419')" name="logisticsInformation">
            <Row type="flex" :gutter="gutterItem">
              <template v-for="(item, index) in logisticsProviderList">
                <Col :span="ItemCol" class="basic_item" :key="index" v-if="item.showStatus">
                  <span class="basic_title">{{ item.name }}</span>
                  <span class="basic_txt">
                  {{ item.paramsKey === 'carrierThirdNo' ? (userInfo.merchantId + detailsData[item.paramsKey]) : detailsData[item.paramsKey] }}
                </span>
                </Col>
              </template>
            </Row>
          </TabPane>
          <TabPane :label="declareTitle" name="declarationInformation">
            <div class="operation_box" style="justify-content: flex-end;">
              <div v-if="declareTalg">
                <Button type="primary" class="mr15" @click="saveDeclareInfo">{{ $t('key1000555') }}</Button>
                <Button @click="cancelSaveDeclareInfo">{{ $t('key1000112') }}</Button>
              </div>
              <div v-else>
                <Button type="primary" v-if="declareData.length === 0 &&
                getPermission('ymsPackageDeclare_update')" @click="addDeclareRow">{{ $t('key1001340') }}</Button>
                <Button type="primary" v-if="declareData.length > 0 &&
                getPermission('ymsPackageDeclare_update')" @click="editDeclareInfo">{{ $t('key1000985') }}</Button>
              </div>
            </div>
            <div class="table_box">
              <Table
                highlight-row
                border
                max-height="450"
                :loading="tableLoading"
                :columns="declareColumns"
                :data="declareData">
              </Table>
            </div>
          </TabPane>
        </Tabs>
      </Card>
    </div>
    <!--订单商品-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1004421') }}</h2>
        </template>
        <div class="table_box">
          <Table highlight-row
            border
            max-height="400"
            :loading="tableLoading"
            :columns="ymsTableColumns"
            :data="ymsTableData">
          </Table>
        </div>
      </Card>
    </div>
    <!--供应商子单-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1004422') }}</h2>
        </template>
        <div class="table_box">
          <Table highlight-row
            border
            max-height="400"
            :loading="tableLoading"
            :columns="supplierTableColumns"
            :data="supplierTableData">
          </Table>
        </div>
      </Card>
    </div>
    <!--打包信息-->
    <div class="basic_information_box" v-if="detailsData.status>=5&& ['TEMU_S', 'TEMU_P'].includes(detailsData.orderType)">
      <Card :bordered="false" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1004423') }}</h2>
        </template>
        <Table
          :highlight-row="false"
          :disabled-hover="true"
          border
          max-height="450"
          :span-method="handleSpan"
          :loading="tableLoading"
          :columns="packagingInfoColumns"
          :data="packagingInfoTableData">
        </Table>
      </Card>
    </div>
    <!--操作日志-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1000288') }}</h2>
        </template>
        <Table
          highlight-row
          border
          max-height="450"
          :loading="tableLoading"
          :columns="operationLogColumns"
          :data="operationLogTableData">
        </Table>
      </Card>
    </div>
  </div>
</template>

<style lang="less" scoped>
.details_box_styles {
  .basic_information_box {
    .steps_box {
      width: 80%;
    }
  }

  .table_box /deep/ .link_box_style {
    a {
      width: inherit !important;
    }
  }
}
</style>

<style>
.table-error-border-tip {
  border: 1px solid red !important;
}
</style>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {
  getAllUsersInfo,
  getAllYmsWarehouseData, getCurrencyData, getDataSetBatchList, getEnumName, getQueryCarrierShippingName, getSupplierData,
  getUserNameByUserId, getWarehouseName, isJSON,
  jumpToTheCourierInquiry, setConfigCharacters, sumAmount
} from "@/utils/common";

export default {
  name: 'orderListDetails',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      ItemCol: 6,
      where: null,
      informationTab: 'mainInformation',
      ymsTableColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000383'),
          key: 'commodityInfo',
          minWidth: 300,
          align: 'left',
          render: (h, params) => {
            let {pictureUrl, name, ymsSpu, ymsProductId, supplierMerchantId, isSelfOperated} = params.row;
            return h('div', {class: 'flex mt10 mb10'},
              [
                v.tableImg(h, params, null, pictureUrl),
                h('div', {
                  class: 'text-align-left pl10'
                }, [
                  h('div', {class: 'flex flex-wrap'}, [
                    isSelfOperated === 1 ? h('Tag', {
                      props: {
                        color: 'primary'
                      },
                      class: 'mr8',
                    }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004308')) : '',
                    h('Alink', {
                      props: {
                        linkName: name,
                        textAlign: 'left',
                        className: 'mb5',
                        AlinkClass: 'ellipsis_1'
                      },
                      on: {
                        AlinkBtn: () => {
                          const {href} = v.$router.resolve({
                            path: isSelfOperated === 1 ? '/selfOperatedProductsDetails' : '/productDetails',
                            query: {
                              type: 'look',
                              productId: ymsProductId,
                              supplierMerchantId: supplierMerchantId
                            }
                          });
                          window.open(href, '_blank');
                        }
                      }
                    }),
                  ]),
                  h('P', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000689') + ymsSpu)
                ])
              ])
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000239'),
          key: 'ymsSkuInfo',
          align: 'left',
          minWidth: 160,
          render: (h, params) => {
            let ymsProductGoodsSpecifications = params.row.ymsProductGoodsSpecifications || [];
            let ymsSku = params.row.ymsSku;
            let spec = ymsProductGoodsSpecifications.map(i => i.value).join(' • ') || '';
            return h('div', {class: 'text-align-left'}, [
              h('P', ymsSku),
              h('P', {class: 'color-green'}, spec)
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003302'),
          key: 'supplierInfo',
          align: 'left',
          minWidth: 160,
          render: (h, params) => {
            let {supplierName, supplierMerchantId, isSelfOperated} = params.row;
            let name = isSelfOperated === 1 ? v.userInfo.userName : supplierName;
            return h('div', {class: 'text-align-left'}, [
              h('P', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002424') + name),
              h('P', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000090') + supplierMerchantId)
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004366'),
          key: 'packageDimensions',
          align: 'center',
          minWidth: 180,
          render: (h, params) => {
            const formatVal = (val) => {
              return (val === 0 || val) ? val : '-';
            };
            let {length, width, height} = params.row;
            return h('P', formatVal(length) + ' * ' + formatVal(width) + ' * ' + formatVal(height));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000589'),
          key: 'productGoodsWeight',
          align: 'center',
          minWidth: 110,
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003803'),
          key: 'quantity',
          align: 'center',
          minWidth: 120,
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004367'),
          key: 'allottedNumber',
          align: 'center',
          minWidth: 120,
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000524'),
          key: 'outOfStockQuantity',
          align: 'center',
          minWidth: 120,
        },
      ],
      ymsTableData: [],
      supplierTableColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004368'),
          key: 'index',
          align: 'center',
          width: 70,
          type: 'index',
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004369'),
          key: 'subPackageCode',
          minWidth: 180,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001098'),
          key: 'supplierMerchantId',
          minWidth: 120,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000695'),
          key: 'skuQuantity',
          minWidth: 100,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004370'),
          key: 'productQuantity',
          minWidth: 100,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004371'),
          key: 'outPackageStatus',
          minWidth: 120,
          align: 'center',
          render: (h, params) => {
            let outPackageStatus = params.row.outPackageStatus;
            let title = getEnumName(v.enumData, 'YmsSubPackageInfoIsOutPackageStatusCoreEnum', outPackageStatus, 'number');
            return h('div', title);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004372'),
          key: 'outOfStockStatus',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            let abnormalStatus = params.row.abnormalStatus; // 异常状态 1.正常 2.缺货
            let estimateArrivalOfGoodsTime = params.row.estimateArrivalOfGoodsTime ?
              v.$uDate.dealTime(params.row.estimateArrivalOfGoodsTime) : null;
            let ymsSubPackageGoodsList = params.row.ymsSubPackageGoodsList || [];
            let abnormalStatusList = ymsSubPackageGoodsList.filter((item) => {
              return item.abnormalStatus === 2;
            });
            if (abnormalStatusList.length > 1) {
              return h('Alink', {
                props: {
                  linkName: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004373'),
                  AlinkClass: 'crimsonRedColor'
                },
                on: {
                  AlinkBtn: () => {
                    v.jumpToSupplierDetails(params);
                  }
                }
              });
            } else {
              if (abnormalStatus === 2) {
                let goodsStatus = ymsSubPackageGoodsList[0].goodsStatus; //货品状态 1.正常 2.停售
                if (goodsStatus === 1) {
                  return h('div', {class: 'crimsonRedColor text-align-left'}, [
                    h('p', {class: 'mt3'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004364')),
                    estimateArrivalOfGoodsTime ? h('p', {class: 'crimsonRedColor mt3 flex flex-direction'}, [
                      h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004361')),
                      h('span', estimateArrivalOfGoodsTime)
                    ]) : '',
                  ]);
                } else if (goodsStatus === 2) {
                  return h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000084'));
                }
              } else {
                return h('p', '-');
              }
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004374'),
          key: 'updatedTime',
          align: 'left',
          sortable: true,
          minWidth: 180,
          render: (h, params) => {
            let updatedTime = params.row.updatedTime;
            let time = updatedTime ? v.$uDate.dealTime(updatedTime, 'fulltime') : '-';
            return h('div', time);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004118'),
          key: 'expressNo',
          align: 'center',
          minWidth: 150,
          render: (h, params) => {
            let expressageNo = params.row.expressageNo;
            let expressageCode = params.row.expressageCode;
            return h('Alink', {
              props: {
                linkName: expressageNo,
                styles: {
                  justifyContent: 'center'
                }
              },
              on: {
                AlinkBtn: () => {
                  jumpToTheCourierInquiry(expressageCode, expressageNo);
                }
              }
            });
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004116'),
          key: 'supplierPickupOrderNumber',
          minWidth: 120,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004375'),
          key: 'isInvalid',
          minWidth: 100,
          align: 'center',
          render(h, params) {
            let isInvalid = params.row.isInvalid; // 是否作废 0:未作废 1:已作废
            let text = isInvalid === 1 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003696') : isInvalid === 0 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004376') : '-';
            return h('p', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'action',
          align: 'center',
          width: 100,
          render: (h, params) => {
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004377'),
                    show: true,
                    clickFn: () => {
                      v.jumpToSupplierDetails(params);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      supplierTableData: [],
      detailsData: {},
      currentStatus: 0,
      stepsList: [],
      showSteps: false,
      declareData: [], //申报信息列表
      declareOpt: {
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
        align: 'center',
        key: 'options',
        render: (h, params) => {
          return h('div', {}, [
            h('span', {
              on: {
                click: () => {
                  v.declareData.splice(params.index + 1, 0, {
                    ymsPackageDeclareId: '',
                    ymsPackageId: this.$route.query.ymsPackageId,
                    merchantId: this.userInfo.merchantId,
                    nameEn: '',
                    nameCn: '',
                    quantity: '',
                    unitWeight: '',
                    unitPrice: '',
                    unitPriceCurrency: null,
                    hsCode: '',
                    location: null,
                    createdTime: '',
                    createdBy: '',
                    updatedTime: '',
                    updatedBy: '',
                    productUrl: '',
                    ymsProductGoodsId: null
                  });
                  v.declareTalg = true;
                }
              },
              style: {
                display: params.index === v.declareData.length - 1 && v.declareTalg
                  ? 'inline-block'
                  : 'none'
              }
            }, [
              h('Icon', {
                props: {
                  type: 'ios-add-circle'
                },
                style: {
                  marginRight: '10px',
                  fontSize: '20px',
                  cursor: 'pointer'
                }
              })
            ]), h('span', {
              on: {
                click: () => {
                  v.declareData.splice(params.index, 1);
                }
              },
              style: {
                display: v.declareTalg
                  ? 'inline-block'
                  : 'none'
              }
            }, [
              h('Icon', {
                props: {
                  type: 'ios-remove-circle'
                },
                style: {
                  fontSize: '20px',
                  cursor: 'pointer'
                }
              })
            ])
          ]);
        }
      },
      declareColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004378'),
          align: 'center',
          key: 'nameCn',
          render: (h, params) => {
            return h('div', {}, [
              h('Input', {
                props: {
                  value: params.row.nameCn
                },
                style: {
                  width: '90px',
                  display: v.declareTalg ? 'block' : 'none',
                  margin: '0 auto'
                },
                class: params.row._nameCnError ? 'table-error-border-tip' : '',
                on: {
                  'on-change'(val) {
                    params.row.nameCn = val.target.value;
                    v.declareData[params.index] = params.row;
                  }
                }
              }), h('span', {
                style: {
                  display: !v.declareTalg ? 'block' : 'none'
                }
              }, params.row.nameCn)
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004379'),
          align: 'center',
          key: 'nameEn',
          render: (h, params) => {
            return h('div', {}, [
              h('Input', {
                props: {
                  value: params.row.nameEn
                },
                style: {
                  width: '90px',
                  display: v.declareTalg ? 'block' : 'none',
                  margin: '0 auto'
                },
                class: params.row._nameEnError ? 'table-error-border-tip' : '',
                on: {
                  'on-change'(val) {
                    params.row.nameEn = val.target.value;
                    v.declareData[params.index] = params.row;
                  }
                }
              }), h('span', {
                style: {
                  display: !v.declareTalg ? 'block' : 'none'
                }
              }, params.row.nameEn)
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004380'),
          align: 'center',
          key: 'unitPrice',
          render: (h, params) => {
            return h('div', {}, [
              h('InputNumber', {
                props: {
                  value: params.row.unitPrice || null,
                  min: 0,
                  max: 9999999
                },
                style: {
                  width: '90px',
                  display: v.declareTalg ? 'block' : 'none',
                  margin: '0 auto'
                },
                class: params.row._unitPriceError ? 'table-error-border-tip' : '',
                on: {
                  'on-change'(val) {
                    params.row.unitPrice = val;
                    v.declareData[params.index] = params.row;
                  }
                }
              }), h('span', {
                style: {
                  display: !v.declareTalg ? 'block' : 'none'
                }
              }, params.row.unitPrice)
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000738'),
          align: 'center',
          key: 'unitPriceCurrency',
          render: (h, params) => {
            return ('div', [
              h('Select', {
                props: {
                  value: params.row.unitPriceCurrency || null,
                  transfer: true,
                  filterable: true
                },
                style: {
                  display: v.declareTalg ? 'block' : 'none'
                },
                class: params.row._unitPriceCurrencyError ? 'table-error-border-tip' : '',
                on: {
                  'on-change'(val) {
                    params.row.unitPriceCurrency = val;
                    v.declareData[params.index] = params.row;
                  }
                }
              }, v.currencyList.map((i, index) => {
                return h('Option', {
                  props: {
                    key: index,
                    value: i.value
                  }
                }, i.label);
              })), h('span', {
                style: {
                  display: !v.declareTalg ? 'block' : 'none'
                }
              }, params.row.unitPriceCurrency)
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004381'),
          align: 'center',
          key: 'unitWeight',
          render: (h, params) => {
            return h('div', {}, [
              h('InputNumber', {
                props: {
                  value: params.row.unitWeight || null,
                  min: 0,
                  max: 9999999
                },
                style: {
                  width: '90px',
                  margin: '0 auto',
                  display: v.declareTalg ? 'block' : 'none'
                },
                class: params.row._unitWeightError ? 'table-error-border-tip' : '',
                on: {
                  'on-change'(val) {
                    params.row.unitWeight = val;
                    v.declareData[params.index] = params.row;
                  }
                }
              }), h('span', {
                style: {
                  display: !v.declareTalg ? 'block' : 'none'
                }
              }, params.row.unitWeight)
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004382'),
          align: 'center',
          key: 'quantity',
          render: (h, params) => {
            return h('div', {}, [
              h('InputNumber', {
                props: {
                  value: params.row.quantity || null,
                  min: 0,
                  max: 9999999
                },
                style: {
                  width: '90px',
                  margin: '0 auto',
                  display: v.declareTalg ? 'block' : 'none'
                },
                class: params.row._quantityError ? 'table-error-border-tip' : '',
                on: {
                  'on-change'(val) {
                    params.row.quantity = val;
                    v.declareData[params.index] = params.row;
                  }
                }
              }), h('span', {
                style: {
                  display: !v.declareTalg
                    ? 'block'
                    : 'none'
                }
              }, params.row.quantity)
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004383'),
          align: 'center',
          key: 'hsCode',
          render: (h, params) => {
            return h('div', {}, [
              h('Input', {
                props: {
                  value: params.row.hsCode
                },
                style: {
                  width: '90px',
                  display: v.declareTalg ? 'block' : 'none',
                  margin: '0 auto'
                },
                class: params.row._hsCodeError ? 'table-error-border-tip' : '',
                on: {
                  'on-change'(val) {
                    params.row.hsCode = val.target.value;
                    v.declareData[params.index] = params.row;
                  }
                }
              }), h('span', {
                style: {
                  display: !v.declareTalg ? 'block' : 'none'
                }
              }, params.row.hsCode)
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004384'),
          align: 'center',
          key: 'productUrl',
          render: (h, params) => {
            return h('div', {}, [
              h('Input', {
                props: {
                  value: params.row.productUrl
                },
                style: {
                  width: '90px',
                  display: v.declareTalg ? 'block' : 'none',
                  margin: '0 auto'
                },
                on: {
                  'on-change'(val) {
                    params.row.productUrl = val.target.value;
                    v.declareData[params.index] = params.row;
                  }
                }
              }), h('span', {
                style: {
                  display: !v.declareTalg ? 'block' : 'none'
                }
              }, params.row.productUrl)
            ]);
          }
        }
      ],
      declareTalg: false,
      declareTitle: h => {
        return h('div', [
          h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004385')),
          h('Icon', {
            props: {type: 'md-close'},
            style: {
              color: '#f00',
              marginLeft: '5px',
              display: v.declareData.length === 0
                ? 'inline-block'
                : 'none'
            }
          }), h('Icon', {
            props: {type: 'md-checkmark'},
            style: {
              color: '#18b566',
              marginLeft: '5px',
              display: v.declareData.length !== 0
                ? 'inline-block'
                : 'none'
            }
          })
        ]);
      },
      addOrEdit: '',
      originalDeclarationData: [],
      operationLogColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004386'),
          key: 'content',
          align: 'left',
          render(h, params) {
            let list = [];
            let content = params.row.content;
            if (content) {
              if (isJSON(content)) {
                let logContent = params.row.logContent;
                if (Array.isArray(logContent)) {
                  logContent.map((item) => {
                    list.push(h('p', {class: 'mt3 mb3'}, item));
                  });
                  return h('div', list);
                } else {
                  return h('p', {class: 'mt5 mb5'}, logContent);
                }
              } else {
                let logContent = params.row.logContent;
                if (logContent) {
                  if (Array.isArray(logContent)) {
                    logContent.map((item) => {
                      list.push(h('p', {class: 'mt3 mb3'}, item));
                    });
                    return h('div', list);
                  } else {
                    return h('p', {class: 'mt5 mb5'}, logContent);
                  }
                } else {
                  // 用;作为需要换行展示
                  content = content.replace(/;/g, '<br/>');
                  return h('div', {
                    domProps: {
                      innerHTML: content
                    }
                  });
                }
              }
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000291'),
          key: 'updatedTime',
          width: 200,
          align: 'center',
          render: (h, params) => {
            return h('div', v.$uDate.getDataToLocalTime(params.row.updatedTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000292'),
          key: 'updatedBy',
          width: 180,
          align: 'center',
          render: (h, params) => {
            let type = params.row.type || '';
            if (v.system === 'yms' && type === 'DISTRIBUTOR_LOG') {
              return h('div', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000293'));
            } else if (v.system === 'distributor' && type === 'SYSTEM_LOG') {
              return h('div', 'YMS');
            } else if (['yms', 'distributor'].includes(v.system) && type === 'SUPPLIER_LOG') {
              return h('div', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000295'));
            } else {
              return h('div', getUserNameByUserId(params.row.updatedBy, v.userInfoList));
            }
          }
        }
      ],
      operationLogTableData: [],
      masterInfoList: [
        {name: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004249')}`, paramsKey: 'packageCode', orderType: true},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004387'), paramsKey: 'labelTypeTxt'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004388'), paramsKey: 'orderShippingId'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001180'), paramsKey: 'createdTime'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004389'), paramsKey: 'warehouseName'}
      ], // 主信息基础数据
      consigneeInfoList: [
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004390'), paramsKey: 'buyerName'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002598'), paramsKey: 'buyerCountryCode'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004391'), paramsKey: 'buyerPassportCode'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003099'), paramsKey: 'buyerName'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001162'), paramsKey: 'buyerState'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003100'), paramsKey: 'buyerMobile'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001175'), paramsKey: 'buyerPhone'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001164'), paramsKey: 'buyerCity'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000068'), paramsKey: 'buyerEmail'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004392'), paramsKey: 'buyerAddress1'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004393'), paramsKey: 'buyerAddress2'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001170'), paramsKey: 'buyerPostalCode'}
      ], // 收货人信息基础数据
      logisticsProviderList: [
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001579'), paramsKey: 'providerName', showStatus: true},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004394'), paramsKey: 'thirdPartyNo', showStatus: true},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004395'), paramsKey: 'providerModeName', showStatus: true},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004396'), paramsKey: 'trackingNumber', showStatus: true},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004397'), paramsKey: 'virtualTrackingNumber', showStatus: true},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004398'), paramsKey: 'carrierWeight', showStatus: true},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004399'), paramsKey: 'estimateFreight', showStatus: true},

        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004400'), paramsKey: 'totalWeight', showStatus: true},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004401'), paramsKey: 'actualWeighingOfTheOrder', showStatus: true},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004402'), paramsKey: 'estimatedShippingCost', showStatus: true},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004403'), paramsKey: 'actualShippingCost', showStatus: true},

        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004404'), paramsKey: 'carrierThirdNo', showStatus: true},
      ], // 物流信息基础数据
      packagingInfoColumns: [
        {
          type: 'index',
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000343'),
          width: 70,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004405'),
          key: 'transferCode',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003698'),
          key: 'trackingNumber',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004406'),
          key: 'skus',
          align: 'center',
          render(h, params) {
            let ymsSku = params.row._productInfo.ymsSku;
            let quantity = params.row.quantity;
            return h('span', ymsSku + ' * ' + quantity);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004407'),
          key: 'userWeight',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'opts',
          align: 'center',
          width: 200,
          render(h, params) {
            let labelPath = params.row.labelPath || '';
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004145'),
                    show: true,
                    clickFn: () => {
                      if (labelPath) {
                        v.commonPrint(labelPath, '1');
                      } else {
                        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004408'));
                        return false;
                      }
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001181'),
                    show: true,
                    clickFn: () => {
                      v.printShippingMarkBtn();
                    }
                  }
                ],
              },
              on: { // 动态设置操作的宽度
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      packagingInfoTableData: [],
      orderTypeObj: {TEMU_S: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004409'), TEMU_P: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004410')},
      orderTypeStyle: {
        marginLeft: '6px',
        border: '1px solid #2D8CF0',
        padding: '1px 4px',
        borderRadius: '4px',
        color: '#2D8CF0',
        lineHeight: 'initial'
      },
      currencyList: [],
      warehouseList: [],
      userInfoList: {}
    };
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    }
  },
  created() {
    this.initFun();
  },
  methods: {
    // 初始化接口数据
    initFun() {
      let v = this;
      v.where = v.$route.query.where ? v.$route.query.where : null;
      (async () => {
        let enumKeyList = [
          'YmsPickupOrderLabelTypeCoreEnum',
          'YmsSubPackageInfoIsOutPackageStatusCoreEnum'
        ];
        v.enumData = await getDataSetBatchList(enumKeyList);
        await getAllYmsWarehouseData().then((data) => {
          v.warehouseList = data;
        });
        await getAllUsersInfo().then((data) => {
          v.userInfoList = data;
        });
        await getCurrencyData().then((data) => {
          v.currencyList = data;
        });
        await v.getDeclarationInfo();
        await v.getDetailsData();
        await v.getLogData();
      })();
    },
    // 返回列表
    goBackBtn() {
      switch (this.where) {
        // 拣货--生成拣货单
        case 'generateOrderList':
          this.$router.push('/wms/generateOrderList');
          break;
        // 组装加工---生成拣货单
        case 'assembleGeneratePickingList':
          this.$router.push('/assembleGeneratePickingList');
          break;
        // 云卖订单
        default:
          this.$router.push('/orderList');
      }
    },
    // 获取订单详情的数据
    getDetailsData() {
      let v = this;
      if (v.getPermission('ymsPackageInfo_detail')) {
        v.stepsList = [];
        v.tableLoading = true;
        v.axios.get(api.get_ymsPackageInfo + `${v.$route.query.ymsPackageId}`).then(response => {
          v.tableLoading = false;
          if (response.data.code === 0) {
            let data = response.data.datas;
            data.warehouseName = getWarehouseName(v.warehouseList, data.ymsWarehouseId);
            data.labelTypeTxt = getEnumName(v.enumData, 'YmsPickupOrderLabelTypeCoreEnum', data.labelType);
            // 获取物流商邮寄方式数据
            if (data.shippingMethodId) {
              getQueryCarrierShippingName([data.shippingMethodId]).then((res) => {
                if (res.length > 0) {
                  res.map((item) => {
                    if (item.shippingMethodId === data.shippingMethodId) {
                      data.providerName = item.carrierName;
                      data.providerModeName = item.carrierShippingMethodName;
                    }
                  });
                }
              });
            }
            /**
             * 只有不是创建状态的时候，才会展示订单流程进度条
             * 订单进度条的展示分两种情况：根据needPurchase字段（是否需要采购字段）和面单类型 展示不同的状态
             */
            // 步骤条时间 ---- 1.已创建 2.备货中 3.待拣货 4.已拣货 5.已换单 6.已装箱 7.已发货
            if (data.status !== 1) {
              // 不需要采购或是云卖面单
              if (data.needPurchase === 0 || data.labelType === 'YMS') {
                // 已创建(createdTime) 已配货(allottedTime) 已拣货(pickedTime) 已换单(changedLabelTime) 已装箱(boxedTime) 已发货(shipedTime)
                v.stepsList = [
                  {currentStatus: 0, icon: 'md-cash', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001799'), time: data.createdTime},
                  {currentStatus: 1, icon: 'md-cart', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004411'), time: data.allottedTime},
                  {currentStatus: 2, icon: 'ios-basket', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004412'), time: data.pickedTime},
                  {currentStatus: 3, icon: 'md-clipboard', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001961'), time: data.changedLabelTime},
                  {currentStatus: 4, icon: 'md-cube', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004130'), time: data.boxedTime},
                  {currentStatus: 5, icon: 'md-car', title: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004365')}${data.warehouseName}）`, time: data.shipedTime}
                ];
                v.showSteps = true;
              }
              // 需要采购且是物流面单类型
              if (data.needPurchase === 1 && data.labelType === 'LOGIS') {
                // 已创建(createdTime) 已换单(changedLabelTime) 已装箱(boxedTime) 已发货(shipedTime)
                v.stepsList = [
                  {currentStatus: 0, icon: 'md-cash', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001799'), time: data.createdTime},
                  {currentStatus: 1, icon: 'md-clipboard', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001961'), time: data.changedLabelTime},
                  {currentStatus: 2, icon: 'md-cube', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004130'), time: data.boxedTime},
                  {currentStatus: 3, icon: 'md-car', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004327'), time: data.shipedTime}
                ];
                // 当允许供应商可直接发货时
                if (data.subPackageInfos) {
                  let arr = [];
                  let choiceTime = null;
                  data.subPackageInfos.map((ele) => {
                    if (ele.isSupplierSupportDirectDelivery === 1) {
                      choiceTime = ele.createdTime;
                      arr.push(ele);
                    }
                  });
                  if (arr.length > 0) {
                    // 已创建(createdTime) 备货中(取供应商子单的创建时间) 已备货(shipedTime) 已发货(shipedTime)
                    v.stepsList = [
                      {currentStatus: 0, icon: 'md-cash', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001799'), time: data.createdTime},
                      {currentStatus: 1, icon: 'ios-cart', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001994'), time: choiceTime},
                      {currentStatus: 2, icon: 'md-cube', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004413'), time: data.shipedTime},
                      {currentStatus: 3, icon: 'md-car', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004327'), time: data.shipedTime}
                    ];
                  }
                }
                v.showSteps = true;
              }
              v.stepsList.map((item) => {
                if (item.time) {
                  v.currentStatus = item.currentStatus;
                  item.time = v.$uDate.dealTime(item.time, 'fulltime');
                }
              });
            } else {
              v.showSteps = false;
            }
            data.createdTime = v.$uDate.dealTime(data.createdTime, 'fulltime');
            let ymsPackageCosts = data.ymsPackageCostList || [];
            // 物流商预估运费
            let estimatedShippingCost = '';
            if (data.payStatus === 1) {
              estimatedShippingCost = v.formatCurrency(data.estimateFreight) + ' ' + data.totalPriceCurrency;
            } else {
              estimatedShippingCost = sumAmount(ymsPackageCosts, 4) || sumAmount(ymsPackageCosts, 9);
            }
            if (data.ymsLogisServiceId) {
              data['actualWeighingOfTheOrder'] = JSON.parse(JSON.stringify(data.carrierWeight)); // 订单实际称重
              data['estimatedShippingCost'] = estimatedShippingCost; // 物流商预估运费
              data['actualShippingCost'] = sumAmount(ymsPackageCosts, 10); // 物流商实际运费
            }
            v.logisticsProviderList.map((item) => {
              if (data.ymsLogisServiceId) {
                if (['carrierWeight', 'estimateFreight'].includes(item.paramsKey)) {
                  item.showStatus = false;
                }
              } else {
                if (['totalWeight', 'actualWeighingOfTheOrder', 'estimatedShippingCost', 'actualShippingCost'].includes(item.paramsKey)) {
                  item.showStatus = false;
                }
              }
            });
            v.detailsData = data;
            if (data.ymsPackageGoods) {
              let newData = v.handleMultilinguaTableFields(data.ymsPackageGoods, ['name', 'title']);
              let supplierMerchantIds = [...new Set(newData.map(i => i.supplierMerchantId).filter(Boolean))];
              getSupplierData(supplierMerchantIds).then((supplierData) => {
                newData.map((item) => {
                  supplierData.map((ele) => {
                    if (item.supplierMerchantId === ele.ymsMerchantId) {
                      item['supplierName'] = ele.name;
                    }
                  })
                });
                v.ymsTableData = newData;
              });
            }
            v.supplierTableData = data.subPackageInfos || [];
            v.handlePackagingInfoData(data.ymsThirdPlatformPackages);
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 获取申报信息
    getDeclarationInfo() {
      let v = this;
      v.axios.get(api.get_ymsPackageDeclare_queryByPackageId + `?packageId=${v.$route.query.ymsPackageId}`).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          v.originalDeclarationData = data.list || [];
          v.declareData = data.list || [];
        }
      });
    },
    // 新增申报信息
    addDeclareRow() {
      this.declareData.splice(1, 0, {
        ymsPackageDeclareId: '',
        ymsPackageId: this.$route.query.ymsPackageId,
        merchantId: this.userInfo.merchantId,
        nameEn: '',
        nameCn: '',
        quantity: '',
        unitWeight: '',
        unitPrice: '',
        unitPriceCurrency: null,
        hsCode: '',
        location: null,
        createdTime: '',
        createdBy: '',
        updatedTime: '',
        updatedBy: '',
        productUrl: '',
        ymsProductGoodsId: null
      });
      this.declareColumns.push(this.declareOpt);
      this.declareTalg = true;
      this.addOrEdit = 'add';
    },
    // 编辑申报信息
    editDeclareInfo() {
      this.declareColumns.push(this.declareOpt);
      this.declareTalg = true;
      this.addOrEdit = 'edit';
    },
    // 保存申报信息
    saveDeclareInfo() {
      let v = this;
      let url = '';
      let text = '';
      let method = '';
      let newArr = [];
      if (v.declareData.length > 0) {
        let arr = ['hsCode', 'nameCn', 'nameEn', 'quantity', 'unitPrice', 'unitPriceCurrency', 'unitWeight'];
        let isValid = true;
        for (let i = 0; i < v.declareData.length; i++) {
          let {_index, _rowKey, ...item} = v.declareData[i];
          for (let key in item) {
            if (arr.includes(key)) {
              if (item[key] === '' || item[key] === null) {
                v.$set(v.declareData[i], '_' + key + 'Error', true);
                isValid = false;
              } else {
                v.$set(v.declareData[i], '_' + key + 'Error', false);
              }

            }
          }
          newArr.push(item);
        }
        if (!isValid) {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004414'));
          return;
        }
        v.tableLoading = true;
        let query = {
          ymsPackageDeclareList: newArr,
          ymsPackageIdList: [v.$route.query.ymsPackageId]
        };
        if (v.addOrEdit === 'add') {
          url = api.post_ymsPackageDeclare;
          text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000456');
          method = 'post';
        } else if (v.addOrEdit === 'edit') {
          url = api.put_ymsPackageDeclare;
          text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002279');
          method = 'put';
        }
        v.axios[method](url, query).then(response => {
          v.tableLoading = false;
          if (response.data.code === 0) {
            v.$Message.success(text);
            this.declareColumns.pop();
            this.declareTalg = false;
            v.addOrEdit = '';
            v.getDeclarationInfo();
            v.informationTab = 'declarationInformation';
          }
        });
      } else {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004415'));
        return false;
      }
    },
    // 取消申报信息
    cancelSaveDeclareInfo() {
      this.declareData = [...this.originalDeclarationData];
      this.declareColumns.pop();
      this.declareTalg = false;
    },
    // 获取操作日志的数据
    getLogData() {
      let v = this;
      v.operationLogTableData = [];
      v.tableLoading = true;
      let query = {
        businessId: v.$route.query.ymsPackageId,
        type: 'SYSTEM_LOG'
      };
      v.axios.post(api.post_ymsLog_queryByBusinessId, query).then((response) => {
        v.tableLoading = false;
        if (response.data.code === 0) {
          let data = response.data.datas || [];
          v.operationLogTableData = v.handleMultilingualLogs(data, v.system);
        }
      });
    },
    // 处理打包信息的数据
    handlePackagingInfoData(data) {
      let v = this;
      v.packagingInfoTableData = [];
      let newList = [];
      let ymsProductGoodsIds = [];
      if (data && data.length > 0) {
        data.map((item) => {
          if (item.ymsThirdPlatformPackageGoods) {
            item.ymsThirdPlatformPackageGoods.map((ele, index) => {
              let length = item.ymsThirdPlatformPackageGoods.length;
              ele['length'] = length;
              ele['currentTalg'] = (length > 1 && index === 0);
              ele['transferCode'] = item.transferCode;
              ele['trackingNumber'] = item.trackingNumber;
              ele['userWeight'] = item.userWeight;
              ele['labelPath'] = item.labelPath;
              newList.push(ele);
            });
          }
        });
        if (newList.length > 0) {
          newList.map((item, index) => {
            item['tableLength'] = newList.length;
            if (item.currentTalg) {
              item['currentIndex'] = index;
            }
            ymsProductGoodsIds.push(item.ymsProductGoodsId);
          });
          if (ymsProductGoodsIds.length > 0) {
            (async () => {
              v.packagingInfoTableData = await v.getProductInfoByIds(ymsProductGoodsIds, newList);
            })();
          }
        }
      }
    },
    // 打印箱唛
    async printShippingMarkBtn() {
      let v = this;
      let ymsCarrierHandoverOrderId = v.detailsData.ymsCarrierHandoverOrderId;
      if (ymsCarrierHandoverOrderId) {
        const {data} = await v.axios.put(api.put_ymsCarrierHandoverOrder_printHandoverOrderForThirdPlatform + ymsCarrierHandoverOrderId);
        if (data.code === 0) {
          this.commonPrint(data.datas, '1');
        }
      } else {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004416'));
        return false;
      }
    },
    // 合并单元格
    handleSpan({row, column, rowIndex, columnIndex}) {
      let columnList = [0, 1, 2, 4, 5];
      if (columnList.includes(columnIndex)) {
        if (row.length > 1) {
          if (rowIndex === row.currentIndex) {
            return [row.length, 1];
          } else {
            for (let i = 0; i <= row.tableLength; i++) {
              if (rowIndex === i) {
                return [0, 0];
              }
            }
          }
        }
      }
    },
    // 跳转供应商详情
    jumpToSupplierDetails(params) {
      let v = this;
      let type = v.where;
      switch (type) {
        case 'generateOrderList':
          pathFun('/generateSupplierOrderDetails', type);
          break;
        case 'assembleGeneratePickingList':
          pathFun('/assembleSupplierOrderDetails', type);
          break;
        default:
          pathFun('/supplierOrderDetails', type);
      }

      function pathFun(path, type) {
        v.$router.push({
          path: path,
          query: {
            ymsPackageId: v.$route.query.ymsPackageId,
            ymsSubPackageId: params.row.ymsSubPackageId,
            where: type
          }
        });
      }
    }
  }
};
</script>
